theme.Events = theme.Events || {};
const Events = theme.Events;

function SubscribeToEvent(eventName, callback) {
  if (Events[eventName] === undefined) {
    Events[eventName] = [];
  }

  Events[eventName] = [...Events[eventName], callback];

  return function UnSubscribeFromEvent() {
    Events[eventName] = Events[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function TriggerEvent(eventName, data) {
  if (Events[eventName]) {
    Events[eventName].forEach((callback) => {
      callback(data);
    });
  }
}